function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "918DA5FE-253C-437F-AD14-E1AC40EB329A");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Landing-page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home-page",
  transform: "translate(-790.000000, -2642.000000)"
}, React.createElement("g", {
  id: "Group-23",
  transform: "translate(790.000000, 2642.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#DAEEFF",
  cx: 12,
  cy: 12,
  r: 12
}), React.createElement("path", {
  d: "M11.6212774,14.7263442 C11.258572,15.0912186 10.670051,15.0912186 10.3075206,14.7263442 L8.27202906,12.6786804 C7.90932365,12.3139822 7.90932365,11.7219418 8.27202906,11.3572435 C8.63455942,10.9923691 9.22308046,10.9923691 9.58578587,11.3572435 L10.7985383,12.5770721 C10.8900899,12.6689951 11.0387081,12.6689951 11.1304348,12.5770721 L14.4142141,9.27365579 C14.7767445,8.9087814 15.3652655,8.9087814 15.7279709,9.27365579 C15.9021466,9.44887297 16,9.68660484 16,9.93437427 C16,10.1821437 15.9021466,10.4198756 15.7279709,10.5950927 L11.6212774,14.7263442 Z",
  id: "Path",
  fill: "#0F5B9B",
  fillRule: "nonzero"
}))));

var SvgTickBlue = function SvgTickBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-blue.e6958d88.svg";
export { ForwardRef as ReactComponent };